import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { configure } from '@taxi/api-client';

import { sessionStore } from './auth/sessionStore';
import { reloadForMissingChunk } from './shell/newBuild';
import './i18n';

// Side-effect import: it registers the listener that follows the operating system at
// sunset and the one that keeps a second tab in step. The first stamp has already
// happened, in the inline script in index.html, before this bundle existed.
import './theme';
import App from './App';
import './index.css';

// The refresh token is kept in localStorage so that F5 does not end a shift — the
// compromise AuthProvider describes. Through the client's store rather than beside it,
// because the client is what rotates the token, and a copy written only at sign-in is a
// used token fifteen minutes later.
configure({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  tokens: sessionStore,
});

// A view this tab had not opened before the last deploy asks for a lazily loaded file the
// new build replaced, and the server answers 404: the map simply fails to appear. Vite
// raises this event for exactly that, and reloading is its own suggested answer — the new
// build has every file it names, and the session survives it. Registered before the first
// render, so no lazy import can fail unheard.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForMissingChunk(() => window.sessionStorage, () => window.location.reload())) {
    event.preventDefault();
  }
});

const container = document.getElementById('root');

if (container === null) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
